<template>
  <div>
    <el-dialog v-loading="loading.dialog" class="task_model_dialog" top="5vh" center :title="newTitle" width="95%"
               :before-close="handleClose" :visible.sync="dialogVisible" :append-to-body="true" :close-on-click-modal="false">
      <el-form size="mini" ref="form" :rules="rules" :model="form">
        <el-form-item label="标题" prop="name" :label-width="formLabelWidth">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="任务内容" prop="taskDetail" :label-width="formLabelWidth">
          <el-input type="textarea" :rows="6" placeholder="请输入内容" v-model="form.taskDetail">
          </el-input>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item label="测试人员" prop="testerId" :label-width="formLabelWidth">
            <el-select autocomplete="off" size="mini" v-model="form.testerId" filterable placeholder="请选择测试人员">
              <el-option v-for="(key, value)  in allUserList.ALLUSERTYPE4" :key="key" :label="key" :value="value" />
            </el-select>
          </el-form-item>
          <el-form-item label="预估工时" prop="estimateWorkHour" :label-width="formLabelWidth">
            <el-input style="width: 92%;" v-model="form.estimateWorkHour" type="number" placeholder="小时" @change="handleEdit">时</el-input>
            <el-tooltip class="item" effect="light" placement="top">
              <div slot="content">
                <span>一天6工时，最多30工时</span>
              </div>
              <i class="el-icon-question" style="color: #409EFF;"></i>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="计划完成日期" prop="planFinishDate" :label-width="formLabelWidth">
            <el-date-picker value-format="yyyy-MM-dd" v-model="form.planFinishDate" type="date" placeholder="请选择时间"
                            :picker-options="pickerOptions_plt" @change="changeDate"/>
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button  style="margin-left:0;" :loading="loading.submit" type="warning" @click="onSubmit">保 存</el-button>
        <el-button type="success" @click="handleClose">关 闭</el-button>
      </div>

    </el-dialog>

  </div>
</template>
<script>
import { Editor } from "@/components/index.js";
import {
  getDevOpsSpaceTaskDetailApi,
  postDevopsSpaceTaskUpdateApi,
  postDevOpsSpaceDeleteTaskApi,
  getListMetersphereBugsApi,
  postDevOpsSpaceCreateTestTaskApi,
  getDevOpsSpaceTestTaskApi,
  getDevOpsSpaceDevelopTestTaskApi,
  postDevOpsSpaceUpdateTestTaskApi,
  postDevOpsSpaceSUbmitTestTaskApi,
  getDevOpsSpaceHistoryTaskListApi,
  postDevOpsSpaceUserPmEditStatusApi,
  getDevOpsSpaceDelayReasonListApi,
  postDevOpsSpaceSUbmitDelayReasonApi
} from "@/server/tops/devOps";
import { formatStrToArr } from "@/views/tops/devOps/components/util.js"
import { mapState } from "vuex";
export default {
  components: { Editor },
  props: {
    formInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    tabid: {
      type: String,
      default: '',
    },
    back: {
      type: String,
      default: '',
    },
    dialogVisible: {
      type: Boolean,
      default: function () {
        return false
      }
    },
    hideDialogVisible: {
      type: Function,
      default: function () {
        return () => { }
      }
    }
  },
  data() {
    return {
      addData: [
      ],
      form: {
        taskHistory: [], // 任务历史
        details: '', // 描述富文本内容
        domain: 'ehsy.com',
        pett: '',
        describe:'',
        taskTime: '',
      },
      rules: {
        name: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        testerId: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        estimateWorkHour: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        planFinishDate: {
          // required: true,
          message: "必填",
          trigger: "blur",
        },
        taskDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      pSubmitForm:{
        reasonCode:'',
        reasonDetail: '',
      },
      pSubmitRules:{
        reasonCode: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
        reasonDetail: {
          required: true,
          message: "必填",
          trigger: "blur",
        },
      },
      formLabelWidth: '140px',
      step: 1, // 1. 编辑 2. 提交
      loading: {
        dialog: false,
        submit: false,
        skip: false,
        submitDelay: false,
      },
      bugOption: {
        count: 0,
        resolved: 0,
        new: 0,
        closed: 0,
        bugs: []
      },
      dialog: {
        bugVisible: false
      },
      username: '',
      pickerOptions_psdt: {
        disabledDate: (time) => {
          return this.disabledDate('psdt', time)
        }
      },
      pickerOptions_pedt: {
        disabledDate: (time) => {
          return this.disabledDate('pedt', time)
        }
      },
      pickerOptions_pstt: {
        disabledDate: (time) => {
          return this.disabledDate('pstt', time)
        }
      },
      pickerOptions_plt: {
        disabledDate: (time) => {
          return this.disabledDate('plt', time)
        }
      },
      link: {
        prdLink: false,
        techDocLink: false
      },
      showDetails: false,
      showLinkTo: false,
      showPLink: false,
      dialogVisibleAllocationTask: false,
      meterspherePlanId: '',
      dialogVisibleTestEnv: false,
      dialogVisibleTestPreEnv: false,
      dialogVisibleTestUatEnv: false,
      dialogVisibleCreateBug: false,
      arrangeInfo: {},
      historylist: [],
      test_task_id: '', //测试任务id
      dev_task_id: '', //开发任务id
      dialogVisibleTask: false,
      formTaskInfo: {},
      userId: '',
      dialogVisibleDelay: false,
      typeList: {},
    };
  },
  async created() {
    const { id = '', openType = '', testerId = ''} = this.formInfo;
    this.form = { ...this.form, ...this.formInfo,testerId: testerId.toString(),openType}
    this.username = this.$store.state.devOps.userInfo.devops_name? this.$store.state.devOps.userInfo.devops_name : '';
    const username = this.username;
    if(this.allUserList.ALLUSERIDLIST1[username]){
      this.userId = this.allUserList.ALLUSERIDLIST1[username];
    }
  },
  computed: {
    ...mapState(
        {
          allSelect: (state) => state.devOps.ALLSELECT,
          allSystem: (state) => state.devOps.ALLSYSTEM,
          allUserList: (state) => state.devOps.ALLUSERLIST,
        }
    ),
    // 是否显示编辑按钮
    showEdit() {
      if (this.isHistoryReviewed) return false;
      if (this.isCreate) return false;
      if (!this.isAdmin) return false;
      return true
    },
    modules() {
      let obj = {}
      const MODULESARR = this.allSelect.MODULESARR || [];
      MODULESARR.filter(itm => itm[2] === this.form.domain).forEach((item) => {
        obj[item[1]] = item[0];
      });
      return obj
    },
    // 判断是否是创建
    isCreate() {
      const { id = '',openType = ''} = this.formInfo?.taskInfo || {};
      return !id || openType === 'copy';
    },
    // 判断是否是创建
    isUpdate(){
      const { id = '',openType = ''} = this.formInfo?.taskInfo || {};
      if(id && openType !== 'copy'){
        return true;
      }
      return false;
    },
    isEditTestTask(){
      return this.step !== 2;
    },
    isTester(){
      if(this.isAdmin || this.isTesterLeader) return true;
      if(this.form.tester){
        return (this.form.tester.nameEn === this.username);
      }
      return false;
    },
    newTitle() {
      if (this.form.openType === 'copy') {
        return '复制测试任务';
      } else if(this.form.id){
        return '编辑测试任务';
      } else {
        return '创建测试任务'
      }
    },
    isAdmin(){
      if(this.username){
        if(this.allUserList.ALLUSERTYPE13 && this.allUserList.ALLUSERTYPE13[this.username]) return true
      }
      return false;
    },
    isTesterLeader(){
      if(this.userId && this.form.tester){
        const testerId = this.form.tester.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[testerId]){
          return this.allUserList.LEADERUSER[testerId] === this.userId;
        }
      }
      return false;
    },
    isReviewerLeader(){
      if(this.userId && this.form.reviewer){
        const reviewerId = this.form.reviewer.id;
        if(this.allUserList.LEADERUSER && this.allUserList.LEADERUSER[reviewerId]){
          return this.allUserList.LEADERUSER[reviewerId] === this.userId ;
        }
      }
      return false;
    },
    isReviewer(){
      if(this.isCreate){
        return true;
      }
      if(this.isAdmin || this.isReviewerLeader) return true;
      if(this.form.reviewer){
        return    this.form.reviewer.nameEn === this.username;
      }
      return false;
    },
    isArrange(){
      return (this.form.test_status === 4 || this.form.test_status === 5 || this.form.test_status === 6) && this.isTester;
    },
    isHistoryReviewed() {
      return this.form.reviewed_status === 'history_reviewed'
    },
    isReviewerAction(){
      if(this.isReviewer && this.step === 2){
        return true;
      }
      return false;
    },
  },
  methods: {
    isReviewerActionDelete(status){
      if(this.isReviewer && this.step === 2 && (status === 0 || status === 1)){
        return true;
      }
      return false;
    },
    getPlanId(PlanId){
      this.meterspherePlanId = PlanId;
    },
    handleSelectionChange(val){
    },
    // 关闭任务弹窗
    handleTaskClose(info = '') {
      this.dialogVisibleTask = false;
    },
    // 跳转外链
    linkFn(url) {
      window.open(url)
    },
    async getHistoryList(){
      await getDevOpsSpaceHistoryTaskListApi({type:4,busiId: this.form.id}).then((res)=>{
        this.historylist = res.data;
      });
    },
    getNowDate(){
      var today = new Date();
      var year = today.getFullYear();//获取年份
      var month = today.getMonth() + 1;//获取月份
      var day = today.getDate();//获取日期
      let cmonth = month < 10 ? '0'+month : month;
      let cday = day < 10 ? '0' + day : day;
      return year + "-" + cmonth + "-" + cday;
    },
    submitUat(){
      let currentTime = Date.parse(this.getNowDate());
      let planFinishDate = Date.parse(this.form.planFinishDate);
      if(currentTime > planFinishDate){
        this.dialogVisibleDelay = true;
      }else{
        this.submitAction(5,'production');
      }
      //this.submitAction(5,'production');
    },
    //提交延期原因
    onSubmitDelay(){
      this.$refs["pSubmitForm"].validate(async (valid) => {
        if (valid) {
          this.$set(this.loading, 'submitDelay', true);
          postDevOpsSpaceSUbmitDelayReasonApi({taskId: Number(this.formInfo.taskInfo.id),reasonCode: Number(this.pSubmitForm.reasonCode),reasonDetail: this.pSubmitForm.reasonDetail,type: 2,is_delay:1}).then((ret)=>{
            if(ret.status === 'success'){
              this.submitAction(5,'production');
            }else{
              this.$notify({
                message: ret.message ||"提交失败",
                type: "error",
              })
            }
            this.loading.submitDelay = false;
          });
        }
      })
    },
    async submitAction(type,env = ''){
      if(type === 6){
        this.$set(this.loading, 'skip', true)
      }else{
        this.$set(this.loading, 'submit', true)
      }
      try {
        const { id = '' } = this.formInfo?.taskInfo || {};
        let params = {
          id:id,
          type:type,
        };
        if(env){
          params.env = env;
        }
        //跳过
        if(type === 6){
          //提交预发环境
          if(this.form.test_status === 4){
            params.stage_id = 7;
            params.stage_name = "tester_testCaseTest";
          }
          //提交uat
          if(this.form.test_status === 5){
            params.stage_id = 11;
            params.stage_name = "tester_stagCaseTest";
          }
        }
        if(type === 2 || type === 4 || type === 5){
          if(!this.meterspherePlanId){
            this.$notify({
              message: '请填写测试用例',
              type: "error",
            })
            return false;
          }
        }
        await postDevOpsSpaceSUbmitTestTaskApi(params).then((res)=>{
          if(res.status === 'success'){
            this.$notify({
              message: res.message || "成功",
              type: "success",
            })
            if(this.form.test_status == 0 || this.form.test_status == 1 || this.form.test_status == 3 || this.form.test_status == 4){
              this.init();
            }else{
              this.hideDialogVisible();
            }
            //this.hideDialogVisible();
          }else{
            this.$notify({
              message: res.message || "失败",
              type: "error",
            })
          }
        });
      } catch (error) {
        this.$notify({
          message: error || "网络错误",
          type: "error",
        })
        this.loading.submit = false;
        this.loading.skip = false;
      } finally {
        this.loading.submit = false;
        this.loading.skip = false;
      }

    },
    //预估工时只能正整数
    handleEdit(e) {
      let value = e.replace(/^(0+)|[^\d]+/g,''); // 以0开头或者输入非数字，会被替换成空
      value = value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
      if(value > 30){
        value = 30;
      }
      this.form.taskTime = value
    },
    onAllocationTask(type,row){
      this.dialogVisibleAllocationTask = true;
    },
    changeDomain(e) {
      delete this.form.module;
    },
    linkToModel(row){
      this.formTaskInfo = {...row,taskId:row.id,name:row.taskName};
      this.dialogVisibleTask = true;
    },
    disabledDate(type, time) {
      const nowTime = Date.now() - 60 * 60 * 24 * 1000;
      const { psdt = '', pedt = '', pstt = '', pett = '', create_time = '', plt = '' } = this.form;
      switch (type) {
        case 'psdt':
          if (pedt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pedt)).getTime()
          }
          if (pstt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
          }
          if (plt) {
            return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
          }
          return time.getTime() <= (new Date(create_time)).getTime() - 60 * 60 * 24 * 1000
        case 'pedt':
          if (psdt) {
            if (pstt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(pstt)).getTime()
            }
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'pstt':
          if (pedt) {
            if (plt) {
              return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            if (plt) {
              return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000 || time.getTime() >= (new Date(plt)).getTime()
            }
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
        case 'plt':
          if (pstt) {
            return time.getTime() <= (new Date(pstt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (pedt) {
            return time.getTime() <= (new Date(pedt)).getTime() - 60 * 60 * 24 * 1000
          }
          if (psdt) {
            return time.getTime() <= (new Date(psdt)).getTime() - 60 * 60 * 24 * 1000
          }
          return time.getTime() <= nowTime
      }
    },
    // 初始化页面
    async init() {
      await this.queryDevOpsSpaceTaskDetail();
      //this.queryListMetersphereBugs();
    },
    getChooseTask(choose){
      this.addData = choose;
    },
    // 获取bug信息
    async queryListMetersphereBugs() {
      try {
        const ret = await getListMetersphereBugsApi({ tid: this.form.id })
        if (ret.status === 'success') {
          this.bugOption = {
            ...ret.count,
            count: ret.data?.length || 0,
            bugs: ret.data || []
          }
        } else {
          this.$notify({
            message: ret.message || '',
            type: "error",
          })
        }
      } catch (error) {
        this.$notify({
          message: error || "获取bug信息失败",
          type: "error",
        })
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceTaskDetail() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceTestTaskApi({
          taskId: this.formInfo.taskInfo.id || ""
        });
        const info = ret.data[0] || {};
        this.form = {
          ...this.form,
          ...info,
          taskDetail: info.taskContent,
          testerId: info.tester.id ? info.tester.id.toString(): '',
          test_status_desc:info.status.desc ? info.status.desc: '',
        };
        await this.DelayReasonList();
      } catch (error) {
        this.$notify({
          message: error || "获取任务详情失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    // 获取任务详情
    async queryDevOpsSpaceDevelopTestTask() {
      this.loading.dialog = true;
      try {
        const ret = await getDevOpsSpaceDevelopTestTaskApi({
          testTaskId: this.formInfo.taskInfo.id || ""
        });
        if(ret.data.length > 0){
          this.addData = ret.data;
        }
      } catch (error) {
        this.$notify({
          message: error || "获取开发任务失败",
          type: "error",
        })
      } finally {
        this.loading.dialog = false;
      }
    },
    async DelayReasonList() {
      await getDevOpsSpaceDelayReasonListApi({type: 2}).then((ret) => {
        let arr = {};
        ret.data.forEach((item) => {
          arr[item.reasonCode] = item.reasonDesc;
        })
        this.typeList = arr;
      });
    },
    // 任务创建及更新
    async onSubmit() {
      this.$refs["form"].validate(async (valid) => {
        if (valid) {
          let type = 'create';
          if(this.form.id){
            type = 'save';
          }
          if(this.form.openType === 'copy'){
            type = 'copy';
          }
          this.form.openType = type;
          this.$emit('changeTestTask',  this.form);
          this.hideDialogVisible();
        }
      })
    },
    onDeleteTestTask(row){
      this.addData = this.addData.filter(function (item) {
        return item.id !== row.id;
      });
      console.log(row);
    },
    // 格式化 props
    formatFormInfo(val) {
      if (val) {
        return val.split(',')
      }
      return []
    },
    changeDate() {
      this.$nextTick(() => {
        this.form.pett = this.form.plt
      })
    },
    // 关闭弹窗
    handleClose() {
      if(this.back){
        this.hideDialogVisible('demand')
      }else{
        this.hideDialogVisible()
      }

    },
    handleAllocationClose(){
      this.dialogVisibleAllocationTask = false;
    },
    toArrange(row){
      let type = '';
      if(this.form.test_status === 4){
        type = 'dialogVisibleTestEnv';
      }else if(this.form.test_status === 5){
        type = 'dialogVisibleTestPreEnv';
      }else if(this.form.test_status === 6){
        type = 'dialogVisibleTestUatEnv';
      }
      this.arrangeInfo = {...row,tester:this.form.tester};
      this[type] = true;
    },
    addBugTask(row){
      this.dev_task_id = row.id;
      this.dialogVisibleCreateBug = true;
    },
    handleCreateBug(){
      this.queryDevOpsSpaceDevelopTestTask();
      this.dialogVisibleCreateBug = false;
    },
    handleTestEnvClose(){
      this.dialogVisibleTestEnv = false;
    },
    handleTestPreEnvClose(){
      this.dialogVisibleTestPreEnv = false;
    },
    handleTestUatEnvClose(){
      this.dialogVisibleTestUatEnv = false;
    },
    // 修改富文本内容
    changeContent(val) {
      this.form.details = val;
    },
    changeDescribeContent(val){
      this.form.describe = val;
    },
    // 任务删除
    onDelete() {
      this.$confirm("此操作将删除该需求, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        this.$set(this.loading, 'delete', true)
        try {
          const res = await postDevOpsSpaceDeleteTaskApi({
            id: this.form.id,
          });
          if (res.status === "success") {
            this.$notify({
              message: "删除成功",
              type: "success",
            })
            this.handleClose();
          } else {
            this.$notify({
              message: res.data.msg || "删除失败",
              type: "error",
            })
          }
        } catch (error) {
          this.$notify({
            message: error || "网络错误",
            type: "error",
          })
        } finally {
          this.loading.delete = false;
        }
      });
    },
    // 从编辑到提交 1 -> 2
    changeStep() {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.$set(this, 'step', 2)
      })
    },
  }
};
</script>
<style lang="scss">
.task_model_dialog {

  .el-form-item__label {
    font-weight: bold;
  }

  .comment_warp {
    .comment_item>div {
      display: flex;
      margin: 0;
      margin-bottom: 12px;

      .el-textarea__inner {
        font-weight: bold;
      }
    }
  }

  .el-dialog__body {
    padding-bottom: 0;
  }

  // #region select
  .el-select__tags {
    flex-wrap: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* IE 10+ */
  }

  .el-select__tags::-webkit-scrollbar {
    display: none;
    /* Chrome Safari */
  }

  .el-input__inner {
    margin-left: -5px;
  }

  // #endregion select
}
.el-form-item__label {
  font-weight: bold;
  font-size: 12px;
}
.task-line{
  height: 1px;
  border-top: 1px solid #ddd;
  text-align: center;
  margin-top: 20px;
}
.task-line label{
  position: relative;
  top: -8px;
  background: #fff;
  padding: 0 20px;
  font-weight: bold;
  color: #606266;
}
.table_text_click_new {
  text-decoration: underline;
  color: #409EFF;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
</style>
